import rpcTenants from './rpc/rpcTenants';

/**
 * Get list of tenants for current user
 * Now uses RPC
 */
export async function getTenants() {
  const { data } = await rpcTenants.getMyTenants();
  if (data?.ok && data.data) {
    return data.data; // Returns { tenants }
  }
  throw new Error(data?.error || 'Failed to fetch tenants');
}

/**
 * Switch to a different tenant
 * Now uses RPC
 */
export async function switchTenant(tenantId: string) {
  const { data } = await rpcTenants.switchTenant({ tenantId });
  if (data?.ok && data.data) {
    return data.data; // Returns { token, tenant, user }
  }
  throw new Error(data?.error || 'Failed to switch tenant');
}
